import { useEffect, useState, useMemo } from 'react';
import '../App.css';
import { makeStyles } from '@material-ui/core';
import { getCoordinates } from '../store/actions/appactions';
import { useSelector, useDispatch } from 'react-redux';
import Footer from './footer';
import { useHistory, useParams } from 'react-router-dom';
import { getDeliveryInfo } from '../store/actions/appactions';
import '../../node_modules/leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
// import { useMap } from 'react-leaflet/hooks'
import icon from "../../node_modules/leaflet/dist/images/marker-icon.png";
import L from "leaflet";
import iconShadow from "../../node_modules/leaflet/dist/images/marker-shadow.png";
import pickupIconPng from "../assets/delivery_truck.png";
import deliveryIconPng from "../assets/house-solid.svg";
import clockIconSvg from "../assets/clock-solid.svg";
import moment, { Moment } from 'moment';


let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

let deliveryIcon = L.icon({
    iconUrl: deliveryIconPng,
    // shadowUrl: deliveryIconPng,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
});

let fattorinoIcon = L.icon({
    iconUrl: pickupIconPng,
    // shadowUrl: pickupIconPng,
    iconAnchor: [15, 15],
    iconSize: [55, 55],
});

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
        height: '100vh'
    },
    iconstwo: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%',
        position: 'relative',
        backgroundColor: '#eeeeee',
        flex: 7,
    },
    iconss: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '90%',
        flex: 1,
    },
    rounddiv: {
        height: '15px',
        width: '15px',
        borderRadius: '7.5px',
        backgroundColor: 'orange'
    },
    heading: {
        textAlign: 'center',
        color: '#909090',
        fontSize: 15,
        maxWidth: 280,
        fontWeight: 500
    },
    headingtwo: {
        fontWeight: 700,
        fontSize: 24,
        maxWidth: '80%',
        textAlign: 'center',
        color: '#393939',
        marginTop: '-10px'
    },
    buttoncontainer: {
        width: '90%'
    },
    headingsix: {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: 0,
        color: '#393939',
        textAlign: 'center'
    },
    spantext: {
        fontSize: 18,
        fontWeight: '400',
        maxWidth: '80%',
        textAlign: 'center',
        color: '#393939',
        marginTop: '-10px'
    },
    spantexttwo: {
        fontSize: 14,
        fontWeight: '400',
        color: '#252525',
        textAlign: 'center'
    },
    spantextthree: {
        fontSize: 14,
        fontWeight: '800',
        color: '#252525',
        textAlign: 'center'
    },
    //    headingone: {
    //        marginBottom: '-20px'
    //    },
    icontext: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        fontWeight: '800',
        textDecoration: 'none',
        color: 'black'
    },
    icontexttwo: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 9,
        fontWeight: '800',
        textDecoration: 'none',
        color: 'black',
    },
    iconsocial: {
        width: 15,
        marginRight: 5
    },
    iconsocialtwo: {
        width: 30,
        color: '#222222'
    },
    typocontainer: {
        width: '90%'
    },
    words: {
        flex: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'center'
    },
    details: {
        backgroundColor: '#fff',
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        borderBottom: "1px solid black",
        paddingBottom: 5,
        paddingTop: 5
    },
    imagecircle: {
        width: 50,
        height: 50,
        borderRadius: 25,
        border: '1px solid black',
        backgroundColor: '#eeeeee',
        overflow: 'hidden'
    },
    detailswords: {
        textAlign: 'center',
        fontWeight: 500,
        fontSize: 12,
        textTransform: 'uppercase',
    },
    detailswordstwo: {
        textAlign: 'center',
        fontWeight: 500,
        fontSize: 10,
        textTransform: 'uppercase',
    },
    pageImage: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'block',
        objectFit: 'cover',
        top: 0,
        left: 0,
        zIndex: 1
    },
    overlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        zIndex: 9,
        backgroundColor: 'rgba(0,0,0,0.3)',
    },
    leafletContainer: {
        width: '100%',
        height: '100vh',
    },
    warningtxt: {
        color: 'red'
    }
}));

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function MapScreen() {
    const classes = useStyles();
    const app = useSelector(state => state.app)
    const data = useSelector((state) => state.app?.userinfo == null ? null : state.app?.userinfo);

    const dispatch = useDispatch();
    const { token } = useParams();
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    const [currentDate, setCurrentDate] = useState(new Date());


    let history = useHistory();


    //custoemr
    const deliveryContactLatitude = app?.userinfo?.deliveryContactLatitude || 45.4644794;
    const deliveryContactLongitude = app?.userinfo?.deliveryContactLongitude || 9.1873669;
    const position = useMemo(() => [deliveryContactLatitude, deliveryContactLongitude], [deliveryContactLatitude, deliveryContactLongitude]);

    // Driver
    const [driverPosition, setDriverPosition] = useState([app?.userinfo?.deliveryDriverLat || null, app?.userinfo?.deliveryDriverLng || null]);

    const dateTo = new Date(app?.userinfo?.taskEtaTo);
    const [shouldShowEta, setShouldShowEta] = useState(true)//dateTo > new Date()
    const [shouldShowMap, setShouldShowMap] = useState(true)//dateTo > new Date()


    const etaData = dateTo.toLocaleDateString();
    const etaTime = dateTo.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    // Delivery
    const [delivery, setDelivery] = useState(data?.steps?.find(elemento => elemento.stepType === 1) || null);
    const [pickup, setPickup] = useState(data?.steps?.find(elemento => elemento.stepType === 0) || null);



    const isNotDeliveryingYet = delivery?.status == 3;
    const needToShowDriverOnMap = delivery?.status == 4;
    const isCompletedSuccessfully = delivery?.status == 5;

    useEffect(() => {
        if (data?.storeId == "3a17cf38-ecdd-21a4-3733-16282edfdb2c") {
            setShouldShowEta(false)
            setShouldShowMap(false)
            console.log("Should Show Eta DISABLED")
        }
    }, [data])
    useEffect(() => {
        console.log("DELIVERYSTATUSNUMBER:::::" + delivery?.status)
        if (delivery?.status != 4) {
            history.push('/confirm/' + token);
        }
    }, [delivery?.status])
    useEffect(() => {
        //console.log(isCompletedSuccessfully, " status -> ", delivery.status)

        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
        if (isCompletedSuccessfully) {
            history.push({
                pathname: '/success/' + token,
            });
        }
        //it's useless to see this page if the driver isn't currently shipping this delivery
        if (isNotDeliveryingYet) {
            history.push({
                pathname: '/confirm/' + token,
            });
        }
    }, [isCompletedSuccessfully, isNotDeliveryingYet])
    useEffect(() => {
        if (token !== undefined) {
            dispatch(getDeliveryInfo(token));
            dispatch(getCoordinates(token))
        }
        // Set refresh timer
        setInterval(() => {
            dispatch(getCoordinates(token))
        }, 15000);
    }, [token, dispatch]);

    useEffect(() => {
        setDriverPosition([app?.userinfo?.deliveryDriverLat || null, app?.userinfo?.deliveryDriverLng || null])
    }, [app.userinfo]);

    useEffect(() => {
        if (app.driverPosition) {
            // let itemData = app.driverPosition.data;
            setDriverPosition([app.driverPosition.data.latitude, app.driverPosition.data.longitude]);
            setCurrentDate(new Date());
        }
    }, [app.driverPosition, dispatch])

    useEffect(() => {
        // let itemData = app.driverPosition.data;
        // driverPosition[0] = app.driverPosition.latitude;
        // driverPosition[1] = app.driverPosition.longitude;
        if (app?.userinfo) {
            let deliveryData = app?.userinfo.steps?.find(elemento => elemento.stepType === 1) || null;
            setDelivery(deliveryData)
        }

    }, [app.userinfo, app.driverPosition, dispatch])


    useEffect(() => {
        window.scroll({
            top: document.body.offsetHeight,
            left: 0,
            behavior: 'smooth',
        });
    }, [])

    const newLocal = <>

        <MapContainer center={position} zoom={12}
            style={{ height: '100%', width: '90%', paddingTop: '5rem' }}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position} icon={deliveryIcon}></Marker>
            ({(needToShowDriverOnMap && driverPosition[0]) && <Marker position={driverPosition} icon={fattorinoIcon}></Marker>})
        </MapContainer>
    </>
    function formatPhoneNumber(number) {
        const nmb = number.split("")
        console.log(nmb)
        nmb?.splice(3, 0, " ")
        console.log(nmb)
        nmb?.splice(7, 0, " ")
        nmb?.splice(12, 0, " ")

        return nmb.join("")

    }
    return (

        <div className={classes.root}>
            <div style={{backgroundColor:'#930483', width: '100%', color:"white", justifyContent:"center", textAlign:"center", alignContent:"center"}}>
                <img height="50%" src="data:image/png;base64,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" class="jss54" alt="Loading"/>
            </div>
            {/* <div>Customer {position[0]} - {position[1]}</div>
            <div>Driver {driverPosition[0]} - {driverPosition[1]}</div> */}
            <br />
            {position != null && position[0] != null && shouldShowMap ? newLocal : null}

            <div className={classes.details} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '2' }}>

                    <span className={windowDimensions.height <= 667 ? classes.detailswordstwo : classes.detailswords}>
                        {delivery?.driver?.split(" ")?.[0] || 'Il Driver'} è in arrivo con il suo ordine <b>{app?.userinfo?.businessPartnerDescription} {app?.userinfo?.externalOrderCode}</b>
                        <br /></span>
                    {delivery?.driverPhone && <a href={"tel:" + delivery?.driverPhone}>{"Contatta il driver al numero: " + formatPhoneNumber(delivery?.driverPhone)}</a>}
                    {shouldShowEta && <span style={{ textTransform: 'none', textAlign: 'left' }}>
                        {app.driverPosition?.data?.estimatedEta!=undefined ? <>                        
                        <img src={clockIconSvg} alt='clock' style={{ width: 11, marginRight: 8 }} />
                            <span>La consegna è prevista alle ore </span>
                            {moment(app.driverPosition?.data?.estimatedEta).format("HH:mm")}</> : ""}


                    </span>}
                </div>
                <div style={{ width: '50px' }}></div>
            </div>
            <div className={classes.words} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '2' }}>
                <span className={classes.spantextthree}>{app?.userinfo?.deliveryContact || '-'}</span>
                {(app?.userinfo?.deliveryInterPhone == false) && <span className={classes.warningtxt}><b>Citofono mancante</b></span>}

                <span className={classes.spantexttwo}>
                    {app?.userinfo?.to || '-'}
                    <br />Citofono: {app?.userinfo?.deliveryInterPhone || '-'}<br />Note: {app?.userinfo?.deliveryNote || '-'}
                </span>
                <br />
            </div>
            <div className={classes.iconss}>
                <Footer />
            </div>
        </div>


    )
}

export default MapScreen;
